//TRIGGER FUNCTIONS ON WINDOW SCROLL

var onScroll = function(event){

    //
    // HEADER
    //
    var st = window.pageYOffset || document.documentElement.scrollTop,
        target = $('header:not(.simple-header)');

    if (st > 70) {
        target.addClass('scrolling');

        if (st < lastY) {
            target.removeClass('scrollDown');

            if(target.hasClass('triggered')) {
                target.removeClass('triggered');
            }

        } else {
            target.addClass('scrollDown');
        }
    } else {
        target.removeClass('scrolling scrollDown');

        if(target.hasClass('triggered')) {
            target.removeClass('triggered');
        }
    }
    lastY = st;

    //
    // SPECIAL OFFER
    //

    var scrollOffer;

    if ($(window).width() > 1080) {

        var offerBottom = parseInt($('.offer-buttons').css('bottom'));
        var offerHeight = $('.offer-buttons').height() / 2;

        scrollOffer = st + $(window).innerHeight() - offerBottom - offerHeight;
        var footerOffset =  $('footer').offset().top;

        var offerPosition = $('footer').outerHeight() - $('.offer-buttons').outerHeight();

        if (scrollOffer >= footerOffset) {
            $('.offer-buttons').css({'position': 'absolute', 'bottom' : offerPosition + 114});
        }

        else if (st + $(window).innerHeight() <= footerOffset) {
            $('.offer-buttons').removeAttr('style');
        }

    }

    var target = $('.offer-buttons');

    if(target.length > 0) {

        var scroll = window.pageYOffset || document.documentElement.scrollTop,
            windowHeight = window.innerHeight,
            sectionOffset;

        if($('section').eq(1).length > 0) {
            sectionOffset = $('section').eq(1).offset().top;

            if(parseInt(scroll) + parseInt(windowHeight) > sectionOffset) {
                target.removeClass('hide');

            }else {
                target.addClass('hide');
            }
        }
    }

};

//TRIGGER FUNCTIONS ON FLAT TABLE SCROLL
var onTableScroll = function(event) {
    if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 20) {
        $(this).closest('.table-container').addClass('shadow-hidden');
    }
    else {
        $(this).closest('.table-container').removeClass('shadow-hidden');
    }
};

$(window).on('scroll', onScroll);
$('.table-content').on('scroll', onTableScroll);
